import { createSlice } from '@reduxjs/toolkit';

import { findManyCategory } from '~/shared/store/slices/categories/thunks';

type CategoriesSliceType = {
  categories: {
    items: Record<string, unknown>[];
    isLoading: boolean;
    isError: boolean;
  };
};

const initialState: CategoriesSliceType = {
  categories: {
    items: [],
    isLoading: false,
    isError: false,
  },
};

export const consultationsSlice = createSlice({
  name: 'consultations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(findManyCategory.pending, (state) => {
        state.categories.isLoading = true;
        state.categories.isError = false;
      })
      .addCase(findManyCategory.fulfilled, (state, action) => {
        state.categories.isLoading = false;
        state.categories.items = action.payload;
      })
      .addCase(findManyCategory.rejected, (state) => {
        state.categories.isLoading = false;
        state.categories.isError = true;
      });
  },
});
